export const ERROR_STARTING_SESSION = 'Error starting session';
export const NODE_ID_UNAVAILABLE = 'Node id unavailable';
export const MOO_WEB_URL = 'moo:msWebUrl';
export const MOO_SESSION_ID = 'moo:sessionNodeId';
export const MOO_SESSION_OWNER = 'moo:acsSessionOwner';
export const ALFRESCO_LOCK_OWNER = 'cm:lockOwner';
export const MSONLINE_EDITING = 'msOnlineEditing';
export const MSONLINE_EDITING_ALLOWED = 'msOnlineEditingAllowed';
